// ============================================================
// BELUMIN NAVBAR — Scroll behavior + Mega menu
// ============================================================
(function () {
  const navbar     = document.getElementById('navbar');
  const navbarWrap = document.getElementById('navbar-wrap');
  if (!navbar) return;

  const threshold     = parseInt(navbar.dataset.scrollThreshold) || 40;
  const TRANSITION_MS = 700;
  let isMegaOpen = false;

  function onScroll() {
    if (isMegaOpen) return;
    navbar.classList.toggle('is-scrolled', window.scrollY > threshold);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // ── Mega menu (click) ──────────────────────────────────────
  const megaTrigger = document.querySelector('[data-mega-trigger]');
  const megaPanel   = document.getElementById('mega-panel');
  const overlay     = document.getElementById('mega-overlay');
  if (!megaTrigger || !megaPanel || !navbarWrap) return;

  function openMega() {
    isMegaOpen = true;
    navbarWrap.classList.add('is-mega-open');
    megaTrigger.setAttribute('aria-expanded', 'true');
    if (overlay) overlay.classList.add('is-active');
  }

  function closeMega() {
    navbarWrap.classList.remove('is-mega-open');
    megaTrigger.setAttribute('aria-expanded', 'false');
    if (overlay) overlay.classList.remove('is-active');

    setTimeout(() => {
      isMegaOpen = false;
      onScroll();
    }, TRANSITION_MS);
  }

  // Toggle on trigger click
  megaTrigger.addEventListener('click', (e) => {
    e.preventDefault();
    isMegaOpen ? closeMega() : openMega();
  });

  // Close on outside click
  document.addEventListener('click', (e) => {
    if (isMegaOpen && !navbarWrap.contains(e.target)) closeMega();
  });

  // Close on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isMegaOpen) closeMega();
  });
})();

// ============================================================
// BELUMIN MOBILE NAV DRAWER
// ============================================================
(function () {
  const trigger   = document.getElementById('mobile-menu-trigger');
  const mobileNav = document.getElementById('mobile-nav');
  if (!trigger || !mobileNav) return;

  function openMenu() {
    trigger.setAttribute('aria-expanded', 'true');
    trigger.classList.add('is-open');
    mobileNav.classList.add('is-open');
    mobileNav.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    trigger.setAttribute('aria-expanded', 'false');
    trigger.classList.remove('is-open');
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  trigger.addEventListener('click', () => {
    trigger.getAttribute('aria-expanded') === 'true' ? closeMenu() : openMenu();
  });

  // Close when a nav link is tapped
  mobileNav.addEventListener('click', (e) => {
    if (e.target.matches('.mobile-nav__link')) closeMenu();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) closeMenu();
  });
})();

// ============================================================
// BELUMIN SEARCH OVERLAY
// ============================================================
(function () {
  const overlay        = document.getElementById('search-overlay');
  const triggers       = document.querySelectorAll('[data-search-trigger]');
  const cancelBtn      = document.getElementById('search-cancel');
  const input          = document.getElementById('search-input');
  const clearBtn       = document.getElementById('search-clear');
  const resultsRow     = document.getElementById('search-results-row');
  const fallbackEl     = document.getElementById('search-fallback');
  const suggestionsEl  = overlay?.querySelector('.search-overlay__suggestions');
  if (!overlay || !triggers.length || !input) return;

  let debounceTimer = null;
  let currentQuery  = '';

  // ── Open / Close ──────────────────────────────────────────
  function openSearch() {
    overlay.classList.add('is-open');
    overlay.removeAttribute('aria-hidden');
    triggers.forEach(t => t.setAttribute('aria-expanded', 'true'));
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(() => input.focus());
  }

  function closeSearch() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    triggers.forEach(t => t.setAttribute('aria-expanded', 'false'));
    document.body.style.overflow = '';
  }

  triggers.forEach(t => t.addEventListener('click', openSearch));
  cancelBtn?.addEventListener('click', closeSearch);

  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) closeSearch();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeSearch();
  });

  // ── Input ─────────────────────────────────────────────────
  input.addEventListener('input', () => {
    const hasValue = input.value.length > 0;
    if (clearBtn) clearBtn.hidden = !hasValue;
    overlay.classList.toggle('has-query', hasValue);
    clearTimeout(debounceTimer);
    if (!hasValue) { clearResults(); return; }
    debounceTimer = setTimeout(() => fetchResults(input.value.trim()), 300);
  });

  clearBtn?.addEventListener('click', () => {
    input.value = '';
    if (clearBtn) clearBtn.hidden = true;
    clearResults();
    input.focus();
  });

  // ── Fetch ─────────────────────────────────────────────────
  async function fetchResults(query) {
    if (!query || query === currentQuery) return;
    currentQuery = query;
    try {
      const url = `/search/suggest?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5&section_id=predictive-search`;
      const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!res.ok) return;
      const doc     = new DOMParser().parseFromString(await res.text(), 'text/html');
      const section = doc.getElementById('shopify-section-predictive-search');
      const content = section?.innerHTML.trim() ?? '';

      if (!content && fallbackEl) {
        showInRow(fallbackEl.innerHTML, query);
        return;
      }
      if (content) showInRow(content, query);
    } catch (_) {}
  }

  function showInRow(html, query) {
    if (!resultsRow) return;
    resultsRow.innerHTML = html;
    const seeAll = document.createElement('a');
    seeAll.href      = `/collections/all`;
    seeAll.className = 'search-card search-card--see-all';
    seeAll.innerHTML = '<span>See<br>All</span>';
    resultsRow.appendChild(seeAll);
    resultsRow.closest('.search-overlay__results')?.classList.add('has-results');
  }

  function clearResults() {
    if (resultsRow) {
      resultsRow.innerHTML = '';
      resultsRow.closest('.search-overlay__results')?.classList.remove('has-results');
    }
    overlay.classList.remove('has-query');
    currentQuery = '';
  }
})();
